import PropTypes from 'prop-types'
import { Input } from 'baseui/input'
import { mergeOverrides } from 'baseui'
import { SDInputOverrides } from './styled-components'
import { Alert, Delete } from 'baseui/icon'
import IconCarbonCheckmarkOutline from '@/shared/icons/IconCarbonCheckmarkOutline'
import InfoIcon from '../icon_info.svg'
import { useEffect, useState } from 'react'
import { EndEnhancerIconContainer, FloatingLabel, RelativeContainer } from '@/shared/theme/styled-components'
import { Spinner } from 'baseui/spinner'

const SDInput = ({ label, overrides, status, currentValue, onBlur, outerOnchange, error, button = null, ...rest }) => {
  const [value, setValue] = useState(currentValue || '')

  const iconMapping = {
    valid: <IconCarbonCheckmarkOutline size={24} color='green' />,
    info: <img src={InfoIcon} alt='Info' style={{ width: 24, height: 24 }} />,
    warning: <Alert size={24} color='orange' />,
    error: <Delete size={24} color='red' />,
    loading: <Spinner size={24} />,
  }

  const iconEndEnhancer = iconMapping[status] ?? null
  const endEnhancerContent = iconEndEnhancer || rest.endEnhancer
  const endEnhancerElement = endEnhancerContent ? (
    <EndEnhancerIconContainer>{endEnhancerContent}</EndEnhancerIconContainer>
  ) : null

  const newOverrides = mergeOverrides(SDInputOverrides(error || false), overrides)

  useEffect(() => {
    if ((currentValue === null || currentValue === undefined) && value !== '') {
      setValue('')
      return
    }
    setValue(currentValue)
  }, [currentValue])

  return (
    <RelativeContainer>
      {label && (
        <FloatingLabel>
          <div dangerouslySetInnerHTML={{ __html: label }} />
        </FloatingLabel>
      )}
      <Input
        {...rest}
        error={error}
        overrides={newOverrides}
        onBlur={e => {
          if (typeof onBlur === 'function') {
            let selectedValue = e.target.value
            if (selectedValue === '') {
              selectedValue = null
            }
            onBlur(selectedValue)
          }
        }}
        onChange={e => {
          const newValue = e.target.value
          setValue(newValue)
          if (typeof outerOnchange === 'function') {
            let selectedValue = newValue
            if (selectedValue === '') {
              selectedValue = null
            }
            outerOnchange(selectedValue)
          }
        }}
        endEnhancer={
          button
            ? () => (
                <>
                  {endEnhancerElement}
                  {button}
                </>
              )
            : endEnhancerElement
        }
        value={value || ''}
      />
    </RelativeContainer>
  )
}

SDInput.propTypes = {
  label: PropTypes.node,
  overrides: PropTypes.object,
  status: PropTypes.oneOf(['valid', 'info', 'warning', 'error']),
  currentValue: PropTypes.any,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
}

export default SDInput
